import { render, staticRenderFns } from "./setUsername.vue?vue&type=template&id=28e95f2c&scoped=true&"
import script from "./setUsername.vue?vue&type=script&lang=js&"
export * from "./setUsername.vue?vue&type=script&lang=js&"
import style0 from "./setUsername.vue?vue&type=style&index=0&id=28e95f2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e95f2c",
  null
  
)

export default component.exports